/* global safari */
import React from "react";

import { Dimmer, Loader } from "semantic-ui-react";

import LoadingScreen from "react-lib/apps/HISV3/common/LoadingScreen";
import { getDeviceIdAndUserSubScription } from "react-lib/apps/HISV3/common/sequence/GetUserSubScription";

import LineLoginManager from "./LineLoginManager";
import SpecifyEmailLogin from "./SpecifyEmailLogin";

import settings from "config/config";

type LineCallBackProps = {
  hostname?: string;
  onLoginFailed?: () => void;
  onLoginSuccess?: (res: any) => void;
};

export default class LineCallBack extends React.Component<LineCallBackProps, any> {
  static defaultProps = {
    onLoginFailed: () => {},
    onLoginSuccess: () => {},
  };

  constructor(props) {
    super(props);

    console.log("LineCallBack props", props);

    this.lineLoginManager = new LineLoginManager();

    const params = new URLSearchParams(globalThis.location.search);

    console.log("LineCallBack URLSearchParams params", params);
    this.stateMatched = this.lineLoginManager.verifyCSRFState(params.get("state"));
    this.code = params.get("code");

    console.log("LineCallBack stateMatched:", this.stateMatched);

    this.state = {
      apiToken: "",
      auth: {},
      email: "",
      isLineSignIn: globalThis.opener?.onLineSignInSuccess,
      message: this.stateMatched ? "Loading ..." : "CSRF's mismatch",
      name: "",
      picture: "",
      showEmailLogin: false,
      success: false,
      userId: "",
    };
  }

  async componentDidMount() {
    let isPrivate = false;

    try {
      isPrivate = safari.self.browserWindow.activeTab.private;
    } catch {
      isPrivate = true;
    }

    console.log("CDM this.stateMatched", this.stateMatched);

    if (this.stateMatched || isPrivate) {
      try {
        await this.lineLoginManager.getToken(this.code);

        if (globalThis.opener?.onLineSignInSuccess) {
          globalThis.opener.onLineSignInSuccess(this.lineLoginManager.auth);

          globalThis.close();
        } else {
          await this.getTokenFromAccount();
        }
      } catch (error) {
        if (error.message?.override_email && settings.COMPANY === "MEHEALTH") {
          this.setState({ showEmailLogin: true });

          return;
        }

        console.log(error, "Line Login Error");
        this.props.onLoginFailed({
          error,
        });

        // this.props.history.push("/");
        // this.setState((state, props) => {
        //   return {
        //     message: err.message,
        //   }
        // });
      }
    }
    // this.props.onLoginFailed({
    //   error: "เกิดข้อผิดพลาด กรุณาปิดโหมด Private"
    // });
  }

  getTokenFromAccount = async () => {
    let _device_id = null;
    let _subscription = null;

    const [deviceId, subscription] = await getDeviceIdAndUserSubScription(true);

    if (deviceId && subscription) {
      _device_id = deviceId;
      _subscription = subscription;
    }

    // Use this to get a PentaCenter API Token
    const pentaToken = await this.lineLoginManager.getTokenFromAccount(
      settings.APP_NAME,
      null,
      _subscription,
      _device_id,
      this.props.hostname
    );

    console.log("pentaToken", pentaToken);
    console.log("_subscription", _subscription);
    console.log("_device_id", _device_id);

    // Optional get profile from LINE API
    const profile = await this.lineLoginManager.getProfile();
    const verify = await this.lineLoginManager.getVerifyIDToken(profile.userId);

    console.log("CDM LineCallback");
    console.log(profile);
    console.log(verify);
    console.log(this.props);

    this.props.onLoginSuccess({
      pentaToken,
      profile,
      verify: { ...verify, type: "line" },
    });

    // this.setState((state, props) => {
    //   return {
    //     userId: profile.userId,
    //     name: verify.name,
    //     picture: verify.picture + '/large',
    //     email: verify.email,
    //     success: true,
    //     apiToken: pentaToken.token,
    //   }
    // });
  };

  handleEmailSubmit = async (email: string) => {
    this.lineLoginManager.auth.override_email = email;

    await this.getTokenFromAccount();
  };

  render() {
    // const { message, userId, name, picture, email, success, apiToken } = this.state;
    // const invalid = <div><h3>{ message }</h3><br /><a className='button' href='/'>BACK</a></div>;
    // const valid = (
    //   <div>
    //     <p>Id: {userId}</p>
    //     <p>Name: {name}</p>
    //     <p>
    //       Picture: {picture}<br/>
    //       <img src={picture} alt='profile' height={200} width='auto' />
    //     </p>
    //     <p>email: {email}</p>
    //     <p>API Token: {apiToken}</p>
    //   </div>
    // );
    if (this.state.showEmailLogin) {
      return <SpecifyEmailLogin onEmailSubmit={this.handleEmailSubmit} />;
    }

    return settings.COMPANY === "MEHEALTH" && !this.state.isLineSignIn ? (
      <LoadingScreen />
    ) : (
      <Dimmer active>
        <Loader />
      </Dimmer>
    );
  }
}
